export default "__VITE_ASSET__Cqc3Z$Oc__"